import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { actionBarUpdate } from "@origin-digital/event-dispatcher";
import { isLandingPath } from "../helpers/routes";

export const useSyncActionBar = (): void => {
  const { pathname } = useLocation();

  useEffect(() => {
    actionBarUpdate({
      mobileNavButton: isLandingPath(pathname) ? "close" : "back",
    });
  }, [pathname]);
};
